import React from 'react';
import cn from 'classnames';

import NoIncidentFree from 'shared/ui/icons/NoIncidentFree';
import Warning from 'shared/ui/icons/Monitors/Warning';

import {isTranslate} from 'shared/lib/lang';

import MainModal from 'shared/ui/Modal/MainModal';
import ModalBodyWrapper from 'shared/ui/Modal/ModalBodyWrapper';
import UpgradeTariffButton from 'shared/ui/Button/UpgradeTariffButton/UpgradeTariffButton';

import {UserTariffCountKey} from '../../model/IUser';
import useIsTariffFeatureUnavailable from '../../model/useIsTariffFeatureUnavailable';

import getExceededModalTexts, {ExceededModalType} from './getExceededModalTexts';

import styles from './ExceededModal.module.scss';

interface IExceededModalProps {
    isOpen: boolean,
    handleClose: () => void,
    type?: ExceededModalType,
}

const tariffFields: Record<ExceededModalType, UserTariffCountKey> = {
    emails: 'additional_emails_max_count_limit',
    telegram_chats: 'telegram_chats_max_count_limit',
    max_chats: 'max_chats_max_count_limit',
    webhooks: 'webhook_max_count_limit',
    status_pages: 'status_pages_max_count_limit',
    reports: 'reports_max_count_limit',
    servers: 'server_max_count_limit',
    alert_rules: 'server_alert_rules_max_count_limit',
    domain_monitors: 'domain_monitor_max_count_limit',
    port_monitors: 'port_monitor_max_count_limit',
};

const ExceededModal: React.FC<IExceededModalProps> = ({
    isOpen,
    handleClose,
    type,
}) => {
    const isUnavailable = useIsTariffFeatureUnavailable(
        type ? tariffFields[type] : 'monitor_max_count_limit',
    );

    const {header, title, text} = getExceededModalTexts(type, isUnavailable ? 'unavailable' : 'exceeded');

    return (
        <MainModal
            header={header}
            open={isOpen}
            handleClose={handleClose}
            size="md"
            dialogClassName={styles.background}
        >
            <ModalBodyWrapper className={styles.container}>
                <div className={cn(styles.icon, {
                    [styles.iconLarge]: isUnavailable,
                    [styles.iconWarning]: !isUnavailable,
                })}>
                    {isUnavailable ? <NoIncidentFree /> : <Warning />}
                </div>
                <span className={styles.title}>
                    {title}
                </span>
                <span className={styles.text}>
                    {text}
                </span>
            </ModalBodyWrapper>
            {!isTranslate() && <UpgradeTariffButton />}
        </MainModal>
    );
};

export default ExceededModal;
